export const dataObligacionesC2026 = [
    {
      fraccion: "I",
      titulo: "El marco normativo aplicable al sujeto obligado",
      cumplimiento: "Aplica",
      excel1: "LGT_65_I.xlsx",
      /* excel2: "",
      excel3: "",
      excel4: "", */
      managerId: null,
    },
    {
      id: 1,
      fraccion: "II",
      titulo: "Estructura Orgánica",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "II-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_II.1.xlsx",
      /*excel2: "LTAIPT_A63F02A_2.xlsx",
      excel3: "LTAIPT_A63F02A_3.xlsx",
      excel4: "LTAIPT_A63F02A_4.xlsx", */
      managerId: 2,
    },
    {
      fraccion: "II-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_II.2.xlsx",
      /*excel2: "LTAIPT_A63F02B_2.xlsx",
      excel3: "LTAIPT_A63F02B_3.xlsx",
      excel4: "LTAIPT_A63F02B_4.xlsx", */
      managerId: 2,
    },
    {
      fraccion: "III",
      titulo: "Facultades de cada área",
      cumplimiento: "Aplica",
      excel2: "LGT_65_III_2.xlsx",
      /*excel2: "LTAIPT_A63F03_2.xlsx",
      excel3: "LTAIPT_A63F03_3.xlsx",
      excel4: "LTAIPT_A63F03_4.xlsx", */
      managerId: null,  
    },
    {
      fraccion: "IV",
      titulo: "Metas y objetivos de las áreas",
      cumplimiento: "Aplica",
      excel2: "LGT_65_IV_2.xlsx",
      managerId: null,
    },
    {
      id: 2,
      fraccion: "V",
      titulo: "Indicadores",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "V-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_V.1_2.xlsx",
      /*excel2: "LTAIPT_A63F02A_2.xlsx",
      excel3: "LTAIPT_A63F02A_3.xlsx",
      excel4: "LTAIPT_A63F02A_4.xlsx", */
      managerId: 5,
    },
    {
      fraccion: "V-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_V.2_2.xlsx",
      /*excel2: "LTAIPT_A63F02B_2.xlsx",
      excel3: "LTAIPT_A63F02B_3.xlsx",
      excel4: "LTAIPT_A63F02B_4.xlsx", */
      managerId: 5,
    },
    {
      fraccion: "VI",
      titulo: "Directorio de las personas servidoras públicas",
      cumplimiento: "Aplica",
      excel1: "LGT_65_VI_2.xlsx",
      /*excel2: "LTAIPT_A63F06_2.xlsx",
      excel3: "LTAIPT_A63F06_3.xlsx",
      excel4: "LTAIPT_A63F06_4.xlsx", */
      managerId: null,
    },
    {
      id: 3,
      fraccion: "VII",
      titulo: "Remuneración bruta y neta",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "VII-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_VII.1.xlsx",
      excel2: "LGT_65_VII.1_2.xlsx",
      /*excel3: "LTAIPT_A63F08A_3.xlsx",
      excel4: "LTAIPT_A63F08A_4.xlsx", */
      managerId: 7,
    },
    {
      fraccion: "VII-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_VII.2_2.xlsx",
      /*excel2: "LGT_65_VII.2_2.xlsx",
      excel3: "LTAIPT_A63F08B_3.xlsx",
      excel4: "LTAIPT_A63F08B_4.xlsx", */
      managerId: 7,
    },
    {
      fraccion: "VIII",
      titulo: "Gastos por concepto de viáticos y representación",
      cumplimiento: "Aplica",
      excel2: "LGT_65_VIII_2.xlsx",
      /*excel2: "LTAIPT_A63F09_2.xlsx",
      excel3: "LTAIPT_A63F09_3.xlsx",
      excel4: "LTAIPT_A63F09_4.xlsx", */
      managerId: null,
    },
    {
      id: 4,
      fraccion: "IX",
      titulo: "Personal plazas y vacantes",
      cumplimiento: "Aplica",
      managerId: null,
    },  
    {
      fraccion: "IX-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_IX.1.xlsx",
      /*excel2: "LTAIPT_A63F10A_2.xlsx",
      excel3: "LTAIPT_A63F10A_3.xlsx",
      excel4: "LTAIPT_A63F10A_4.xlsx", */
      managerId: 9,
    },
    {
      fraccion: "IX-2",
      titulo:"---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_IX.2.xlsx",
      /*excel2: "LTAIPT_A63F10B_2.xlsx",
      excel3: "LTAIPT_A63F10B_3.xlsx",
      excel4: "LTAIPT_A63F10B_4.xlsx", */
      managerId: 9,
    },
    {
      fraccion: "X",
      titulo: "Contrataciones de servicios profesionales por honorarios",
      cumplimiento: "Aplica",
      excel1: "LGT_65_X.xlsx",
      /*excel2: "LTAIPT_A63F11_2.xlsx",
      excel3: "LTAIPT_A63F11_3.xlsx",
      excel4: "LTAIPT_A63F11_4.xlsx", */
      managerId: null,
    },
    {
      fraccion: "XI",
      titulo:"Versión pública de las declaraciones patrimoniales",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XI.xlsx",
      /*excel2: "LTAIPT_A63F13_2.xlsx",
      excel3: "LTAIPT_A63F13_3.xlsx",
      excel4: "LTAIPT_A63F13_4.xlsx", */
      managerId: null,
    },
    {
      fraccion: "XII",
      titulo: "Domicilio de la Unidad de Transparencia",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XII.xlsx",
      /*excel2: "LTAIPT_A63F13_2.xlsx",
      excel3: "LTAIPT_A63F13_3.xlsx",
      excel4: "LTAIPT_A63F13_4.xlsx", */
      managerId: null,
    },
    {
      fraccion: "XIII",
      titulo: "Convocatorias a concursos para ocupar cargos públicos",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XIII.xlsx",
      /*excel2: "LTAIPT_A63F14_2.xlsx",
      excel3: "LTAIPT_A63F14_3.xlsx",
      excel4: "LTAIPT_A63F14_4.xlsx", */
      managerId: null,
    },
    {
      id: 5,
      fraccion: "XV",
      titulo: "Condiciones generales de trabajo",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XV-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XV.1.xlsx",
      /*excel2: "LTAIPT_A63F14_2.xlsx",
      excel3: "LTAIPT_A63F14_3.xlsx",
      excel4: "LTAIPT_A63F14_4.xlsx", */
      managerId: 15,
    },
    {
      fraccion: "XV-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XV.2.xlsx",
      /*excel2: "LTAIPT_A63F14_2.xlsx",
      excel3: "LTAIPT_A63F14_3.xlsx",
      excel4: "LTAIPT_A63F14_4.xlsx", */
      managerId: 15,
    },
    {
      fraccion: "XVI",
      titulo: "Información curricular",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XVI.xlsx",
      /*excel2: "LTAIPT_A63F17_2.xlsx",
      excel3: "LTAIPT_A63F17_3.xlsx",
      excel4: "LTAIPT_A63F17_4.xlsx", */
      managerId: null,
    },
    {
      fraccion: "XVII",
      titulo: "Personas servidoras públicas con sanciones administrativas",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XVII.xlsx",
      /*excel2: "LTAIPT_A63F17_2.xlsx",
      excel3: "LTAIPT_A63F17_3.xlsx",
      excel4: "LTAIPT_A63F17_4.xlsx", */
      managerId: null,
    },
    {
      id: 6,
      fraccion: "XVIII",
      titulo: "Servicios y trámites que se ofrecen",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XVIII-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XVIII.1.xlsx",
      /*excel2: "LTAIPT_A63F17_2.xlsx",
      excel3: "LTAIPT_A63F17_3.xlsx",
      excel4: "LTAIPT_A63F17_4.xlsx", */
      managerId: 18,
    },
    {
      fraccion: "XVIII-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XVIII.2.xlsx",
      /*excel2: "LTAIPT_A63F17_2.xlsx",
      excel3: "LTAIPT_A63F17_3.xlsx",
      excel4: "LTAIPT_A63F17_4.xlsx", */
      managerId: 18,
    },

    {
      id: 19,
      fraccion: "XIX",
      titulo: "Información financiera sobre el presupuesto",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XIX-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XIX.1_2.xlsx",
      /*excel2: "LTAIPT_A63F17_2.xlsx",
      excel3: "LTAIPT_A63F17_3.xlsx",
      excel4: "LTAIPT_A63F17_4.xlsx", */
      managerId: 19,
    },
    {
      fraccion: "XIX-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XIX.2_2.xlsx",
      /*excel2: "LTAIPT_A63F17_2.xlsx",
      excel3: "LTAIPT_A63F17_3.xlsx",
      excel4: "LTAIPT_A63F17_4.xlsx", */
      managerId: 19,
    },
    {
      fraccion: "XIX-3",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XIX.3_2.xlsx",
      /*excel2: "LTAIPT_A63F17_2.xlsx",
      excel3: "LTAIPT_A63F17_3.xlsx",
      excel4: "LTAIPT_A63F17_4.xlsx", */
      managerId: 19,
    },

    {
      id: 21,
      fraccion: "XXI",
      titulo: "Montos destinados a gastos relativos a comunicación social y publicidad oficial ",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XXI-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXI.1_2.xlsx",
      /*excel2: "LTAIPT_A63F18_2.xlsx",
      excel3: "LTAIPT_A63F18_3.xlsx",
      excel4: "LTAIPT_A63F18_4.xlsx", */
      managerId: 21,
    },
    {
      fraccion: "XXI-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXI.2_2.xlsx",
      /*excel2: "LTAIPT_A63F18_2.xlsx",
      excel3: "LTAIPT_A63F18_3.xlsx",
      excel4: "LTAIPT_A63F18_4.xlsx", */
      managerId: 21,
    },
    {
      fraccion: "XXI-3",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXI.3_2.xlsx",
      /*excel2: "LTAIPT_A63F18_2.xlsx",
      excel3: "LTAIPT_A63F18_3.xlsx",
      excel4: "LTAIPT_A63F18_4.xlsx", */
      managerId: 21,
    },
    {
      fraccion: "XXII",
      titulo: "Informes de resultados de las auditorías",
      cumplimiento: "Aplica",
      managerId: null,
      excel1: "LGT_65_XXII.xlsx",
      /*excel2: "LTAIPT_A63F18_2.xlsx",
      excel3: "LTAIPT_A63F18_3.xlsx",
      excel4: "LTAIPT_A63F18_4.xlsx", */
    },
    {
      fraccion: "XXIII",
      titulo: "Resultado de la dictaminación de los estados financieros",
      cumplimiento: "Aplica",
      managerId: null,
      excel2: "LGT_65_XXIII_2.xlsx",
      /*excel2: "LTAIPT_A63F18_2.xlsx",
      excel3: "LTAIPT_A63F18_3.xlsx",
      excel4: "LTAIPT_A63F18_4.xlsx", */
    },
    {
      fraccion: "XXIV",
      titulo: "Personas físicas o morales a quienes que usen recursos públicos",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXIV_2.xlsx",
      /*excel2: "LTAIPT_A63F24_2.xlsx",
      excel3: "LTAIPT_A63F24_3.xlsx", 
      excel4: "LTAIPT_A63F24_4.xlsx", */
      managerId: null,
    },
    {
      fraccion: "XXV",
      titulo: "Concesiones, contratos, convenios",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXV_2.xlsx",
      /*excel2: "LTAIPT_A63F24_2.xlsx",
      excel3: "LTAIPT_A63F24_3.xlsx", 
      excel4: "LTAIPT_A63F24_4.xlsx", */
      managerId: null,
    },
    {
      fraccion: "XXVI",
      titulo: "Resultados de los procedimientos de adjudicación",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXVI_2.xlsx",
      /*excel2: "LTAIPT_A63F24_2.xlsx",
      excel3: "LTAIPT_A63F24_3.xlsx", 
      excel4: "LTAIPT_A63F24_4.xlsx", */
      managerId: null,
    },
    {
      fraccion: "XXVII",
      titulo:"Informes",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XXVII.xlsx",
      /*excel2: "LTAIPT_A63F27_2.xlsx",
      excel3: "LTAIPT_A63F27_3.xlsx",
      excel4: "LTAIPT_A63F27_4.xlsx", */
      managerId: null,
    },
    {
      fraccion: "XXVIII",
      titulo:"Estadisticas",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XXVIII.xlsx",
      /*excel2: "LTAIPT_A63F27_2.xlsx",
      excel3: "LTAIPT_A63F27_3.xlsx",
      excel4: "LTAIPT_A63F27_4.xlsx", */
      managerId: null,
    },
    {
      id: 29,
      fraccion: "XXIX",
      titulo: "Informes de avances programáticos o presupuestales",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XXIX-1",
      titulo: "",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXIX.1_2.xlsx",
      /*excel2: "LTAIPT_A63F28_2.xlsx",
      excel3: "LTAIPT_A63F28_3.xlsx",
      excel4: "LTAIPT_A63F28_4.xlsx", */
      managerId: 29,
    },
    {
      fraccion: "XXIX-2",
      titulo: "",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXIX.2_2.xlsx",
      /*excel2: "LTAIPT_A63F28_2.xlsx",
      excel3: "LTAIPT_A63F28_3.xlsx",
      excel4: "LTAIPT_A63F28_4.xlsx", */
      managerId: 29,
    },
    {
      fraccion: "XXX",
      titulo: "Padrón de proveedores",
      cumplimiento: "Aplica",
      managerId: null,
      excel2: "LGT_65_XXX_2.xlsx",
      /*excel2: "LTAIPT_A63F29_2.xlsx",
      excel3: "LTAIPT_A63F29_3.xlsx",
      excel4: "LTAIPT_A63F29_4.xlsx", */
    },
    {
      fraccion: "XXXI",
      titulo: "Convenios de coordinación",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XXXI.xlsx",
      /*excel2: "LTAIPT_A63F30_2.xlsx",
      excel3: "LTAIPT_A63F30_3.xlsx",
      excel4: "LTAIPT_A63F30_4.xlsx", */
      managerId: null,
    },
    
    {
      id: 32,
      fraccion: "XXXII",
      titulo: "Inventario de bienes muebles e inmuebles",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XXXII-1",
      titulo: "",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXXII.1_2.xlsx",
      /*excel2: "LTAIPT_A63F31B_2.xlsx",*/
      managerId: 32,
    },
    {
      fraccion: "XXXII-2",
      titulo: "",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXXII.2_2.xlsx",
      /*excel1: "LTAIPT_A63F31B_1.xlsx",
      excel2: "LTAIPT_A63F31B_2.xlsx",*/
      managerId: 32,
    },
    {
      fraccion: "XXXII-3",
      titulo: "",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXXII.3_2.xlsx",
      /*excel1: "LTAIPT_A63F31B_1.xlsx",
      excel2: "LTAIPT_A63F31B_2.xlsx",*/
      managerId: 32,
    },
    {
      fraccion: "XXXII-4",
      titulo: "",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXXII.4_2.xlsx",
      /*excel1: "LTAIPT_A63F31B_1.xlsx",
      excel2: "LTAIPT_A63F31B_2.xlsx",*/
      managerId: 32,
    },
    {
      fraccion: "XXXII-5",
      titulo: "",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXXII.5_2.xlsx",
      /*excel1: "LTAIPT_A63F31B_1.xlsx",
      excel2: "LTAIPT_A63F31B_2.xlsx",*/
      managerId: 32,
    },
    {
      fraccion: "XXXII-6",
      titulo: "",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXXII.6_2.xlsx",
      /*excel1: "LTAIPT_A63F31B_1.xlsx",
      excel2: "LTAIPT_A63F31B_2.xlsx",*/
      managerId: 32,
    },
    {
      fraccion: "XXXII-7",
      titulo: "",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXXII.7_2.xlsx",
      /*excel1: "LTAIPT_A63F31B_1.xlsx",
      excel2: "LTAIPT_A63F31B_2.xlsx",*/
      managerId: 32,
    },

    {
      id: 33,
      fraccion: "XXXIII",
      titulo: "Recomendaciones emitidas por órganos garantes de derechos humanos",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XXXIII-1",
      titulo: "",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XXXIII.1.xlsx",
      /*excel2: "LTAIPT_A63F31B_2.xlsx",
      excel1: "LTAIPT_A63F31B_1.xlsx",
      excel2: "LTAIPT_A63F31B_2.xlsx",*/
      managerId: 33,
    },
    {
      fraccion: "XXXIII-2",
      titulo: "",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XXXIII.2.xlsx",
      /*excel2: "LTAIPT_A63F31B_2.xlsx",
      excel1: "LTAIPT_A63F31B_1.xlsx",
      excel2: "LTAIPT_A63F31B_2.xlsx",*/
      managerId: 33,
    },
    {
      fraccion: "XXXIII-3",
      titulo: "",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XXXIII.3.xlsx",
      /*excel2: "LTAIPT_A63F31B_2.xlsx",
      excel1: "LTAIPT_A63F31B_1.xlsx",
      excel2: "LTAIPT_A63F31B_2.xlsx",*/
      managerId: 33,
    },
    {
      fraccion: "XXXIV",
      titulo: "Resoluciones",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XXXIV.xlsx",
      /*excel2: "LTAIPT_A63F32_2.xlsx",
      excel3: "LTAIPT_A63F32_3.xlsx",
      excel4: "LTAIPT_A63F32_4.xlsx", */
      managerId: null,
    },
    
    {
      id: 35,
      fraccion: "XXXV",
      titulo: "Mecanismos de participación ciudadana",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XXXV-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXXV.1_2.xlsx",
      /*excel2: "LTAIPT_A63F35A_2.xlsx",
      excel3: "LTAIPT_A63F35A_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 35,
    },
    {
      fraccion: "XXXV-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXXV.2_2.xlsx",
      /*excel2: "LTAIPT_A63F35B_2.xlsx",
      excel3: "LTAIPT_A63F35B_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 35,
    },

    {
      id: 37,
      fraccion: "XXXVII",
      titulo: "Actas y resoluciones del Comité de Transparencia",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XXXVII-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XXXVII.1.xlsx",
      /*excel2: "LTAIPT_A63F35A_2.xlsx",
      excel3: "LTAIPT_A63F35A_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 37,
    },
    {
      fraccion: "XXXVII-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XXXVII.2.xlsx",
      /*excel2: "LTAIPT_A63F35A_2.xlsx",
      excel3: "LTAIPT_A63F35B_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 37,
    },
    {
      fraccion: "XXXVII-3",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XXXVII.3.xlsx",
      /*excel2: "LTAIPT_A63F35A_2.xlsx",
      excel3: "LTAIPT_A63F35A_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 37,
    },
    {
      fraccion: "XXXVII-4",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XXXVII.4.xlsx",
      /*excel2: "LTAIPT_A63F35A_2.xlsx",
      excel3: "LTAIPT_A63F35B_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 37,
    },
    {
      fraccion: "XXXIX",
      titulo: "Estudios financiados con recursos públicos",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XXXIX_2.xlsx",
      /*excel2: "LTAIPT_A63F30_2.xlsx",
      excel3: "LTAIPT_A63F30_3.xlsx",
      excel4: "LTAIPT_A63F30_4.xlsx", */
      managerId: null,
    },
    {
      fraccion: "XL",
      titulo: "El listado de personas jubiladas y pensionadas",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XL.xlsx",
      /*excel2: "LTAIPT_A63F30_2.xlsx",
      excel3: "LTAIPT_A63F30_3.xlsx",
      excel4: "LTAIPT_A63F30_4.xlsx", */
      managerId: null,
    },
{
      id: 41,
      fraccion: "XLI",
      titulo: "Ingresos recibidos",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XLI-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XLI.1_2.xlsx",
      /*excel2: "LTAIPT_A63F35A_2.xlsx",
      excel3: "LTAIPT_A63F35A_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 41,
    },
    {
      fraccion: "XLI-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XLI.2_2.xlsx",
      /*excel1: "LTAIPT_A63F35B_1.xlsx",
      excel2: "LTAIPT_A63F35B_2.xlsx",
      excel3: "LTAIPT_A63F35B_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 41,
    },

    {
      id: 43,
      fraccion: "XLIII",
      titulo: "Catálogo de disposición y guía de archivo documental",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XLIII-1",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F35A_1.xlsx",
      excel2: "LTAIPT_A63F35A_2.xlsx",
      excel3: "LTAIPT_A63F35A_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 43,
    },
    {
      fraccion: "XLIII-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XLIII.2.xlsx",
      /*excel2: "LTAIPT_A63F35B_2.xlsx",
      excel3: "LTAIPT_A63F35B_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 43,
    },
    {
      fraccion: "XLIII-3",
      titulo: "---",
      cumplimiento: "Aplica",
      excel2: "LGT_65_XLIII.3_2.xlsx",
      /*excel2: "LTAIPT_A63F35A_2.xlsx",
      excel3: "LTAIPT_A63F35A_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 43,
    },

    {
      id: 44,
      fraccion: "XLIV",
      titulo: "Actas de sesiones, opiniones y recomendaciones de los consejos consultivos",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XLIV-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XLIV.1.xlsx",
      /*excel2: "LTAIPT_A63F35A_2.xlsx",
      excel3: "LTAIPT_A63F35A_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 44,
    },
    {
      fraccion: "XLIV-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XLIV.2_2.xlsx",
      /*excel2: "LTAIPT_A63F35B_2.xlsx",
      excel3: "LTAIPT_A63F35B_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 44,
    },

    {
      id: 46,
      fraccion: "XLVI",
      titulo: "Información relevante",
      cumplimiento: "Aplica",
      managerId: null,
    },
    {
      fraccion: "XLVI-1",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XLVI.1.xlsx",
      /*excel2: "LTAIPT_A63F35A_2.xlsx",
      excel3: "LTAIPT_A63F35A_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 46,
    },
    {
      fraccion: "XLVI-2",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XLVI.2.xlsx",
      /*excel2: "LTAIPT_A63F35B_2.xlsx",
      excel3: "LTAIPT_A63F35B_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 46,
    },
    {
      fraccion: "XLVI-3",
      titulo: "---",
      cumplimiento: "Aplica",
      excel1: "LGT_65_XLVI.3.xlsx",
      /*excel2: "LTAIPT_A63F35B_2.xlsx",
      excel3: "LTAIPT_A63F35B_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 46,
    },
    {
      fraccion: "XLVI-4",
      titulo: "---",
      cumplimiento: "Aplica",
      /*excel1: "LTAIPT_A63F35B_1.xlsx",
      excel2: "LTAIPT_A63F35B_2.xlsx",
      excel3: "LTAIPT_A63F35B_3.xlsx",
      excel4: "LTAIPT_A63F35B_4.xlsx", */
      managerId: 46,
    },
  ];
  